module.exports = __webpack_public_path__ + "img/instructions_1@3x.0832f9d1.png";